// 2023 Topps Star Wars Sapphire — Return of the Jedi 40th Anniversary.
// Topps.com online exclusive (product 5329; released July 12, 2023). Chromium Sapphire
// reprint of the complete 1983 Topps Return of the Jedi set: Series 1 (1-132) and
// Series 2 (133-220), including the three checklist cards (131, 132, 220).
// Cards verified against the official Topps checklist PDF (SWSapphireROTJ.pdf);
// parallel ladder and odds verified against the official Topps odds sheet
// (2023ToppsStarWarsReturnoftheJedi40thSapphireOdds.pdf, via Cardboard Connection's
// mirror). No unnumbered-refractor tier exists — Aqua /75 is the entry parallel.
// Verbatim 1983/Topps text kept on purpose — do not "fix":
//   #19 "Beedo and a Jawa" (1983's own Greedo typo), #98 "Hans Solo's Approach",
//   #220 "Checklist 133-172", sticker #17 "Lando Calrission" — all as printed on
//   the official checklist.
// The four puzzles (Jabba/Green, Rancor/Purple, Millennium Falcon Cockpit/Blue,
// Ewok/Red) are the colored puzzle backs of the Chrome Sticker Reprints, as in 1983 —
// not separate cards, and they carry no odds line; intentionally not card rows.
// The official PDF's autograph table has its code and signer columns independently
// sorted (it pairs ROTJ-CF with Harrison Ford); pairing below follows the codes'
// initials, confirmed via Cardboard Connection.
// 1983 buyback redemptions (1:4,117 packs) have no published checklist;
// intentionally not represented as card rows.

const BASE_P = [
  {id:"aqua-sapphire",name:"Aqua Sapphire",print_run:75,color:"#00e5ff"},
  {id:"green-sapphire",name:"Green Sapphire",print_run:60,color:"#5fd35f"},
  {id:"orange-sapphire",name:"Orange Sapphire",print_run:25,color:"#ff9d52"},
  {id:"gold-sapphire",name:"Gold Sapphire",print_run:15,color:"#f0c040"},
  {id:"purple-sapphire",name:"Purple Sapphire",print_run:10,color:"#cb7dff"},
  {id:"red-sapphire",name:"Red Sapphire",print_run:5,color:"#ff5d5d"},
  {id:"onyx-sapphire",name:"Onyx Sapphire",print_run:1,color:"#a8a8b4"},
];

export const SETS = [
  {
    id: "base-series-1", type: "base", title: "BASE SERIES 1 — 132 CARDS",
    parallels: BASE_P,
    cards: [
      {n:"1", name:"132 Cards - 33 Stickers", artist:null},
      {n:"2", name:"Luke Skywalker", artist:null},
      {n:"3", name:"Darth Vader", artist:null},
      {n:"4", name:"Han Solo", artist:null},
      {n:"5", name:"Princess Leia Organa", artist:null},
      {n:"6", name:"Lando Calrissian", artist:null},
      {n:"7", name:"Chewbacca", artist:null},
      {n:"8", name:"C-3PO and R2-D2", artist:null},
      {n:"9", name:"The New Death Star", artist:null},
      {n:"10", name:"The Inspection", artist:null},
      {n:"11", name:"Toward the Desert Palace", artist:null},
      {n:"12", name:"Bib Fortuna", artist:null},
      {n:"13", name:"Court of Evil", artist:null},
      {n:"14", name:"Jabba the Hutt", artist:null},
      {n:"15", name:"Intergalactic Gangster", artist:null},
      {n:"16", name:"Salacious Crumb", artist:null},
      {n:"17", name:"A Message for Jabba the Hutt", artist:null},
      {n:"18", name:"Dungeons of Jabba the Hutt", artist:null},
      {n:"19", name:"Beedo and a Jawa", artist:null},
      {n:"20", name:"Sy Snootles and the Rebo Band", artist:null},
      {n:"21", name:"Droopy McCool", artist:null},
      {n:"22", name:"Sy Snootles", artist:null},
      {n:"23", name:"Watched by Boba Fett", artist:null},
      {n:"24", name:"Boushh's Captive", artist:null},
      {n:"25", name:"The Bounty Hunter Boushh", artist:null},
      {n:"26", name:"The Villains Confer", artist:null},
      {n:"27", name:"Han Solo's Plight", artist:null},
      {n:"28", name:"The Rescuer", artist:null},
      {n:"29", name:"Decarbonized!", artist:null},
      {n:"30", name:"Princess Leia to the Rescue!", artist:null},
      {n:"31", name:"Heroes in Disguise", artist:null},
      {n:"32", name:"The Princess Apprehended", artist:null},
      {n:"33", name:"Luke Skywalker Arrives", artist:null},
      {n:"34", name:"The Young Jedi", artist:null},
      {n:"35", name:"The Court in Chaos!", artist:null},
      {n:"36", name:"The Rancor Pit", artist:null},
      {n:"37", name:"Facing Jabba the Hutt", artist:null},
      {n:"38", name:"The Sail Barge and the Desert Skiff", artist:null},
      {n:"39", name:"Jabba the Hutt's New Dancing Girl", artist:null},
      {n:"40", name:"On the Sail Barge", artist:null},
      {n:"41", name:"A Monstrous Fate!", artist:null},
      {n:"42", name:"The Battle Begins", artist:null},
      {n:"43", name:"Lando Calrissian's Fight for Life", artist:null},
      {n:"44", name:"Fury of the Jedi!", artist:null},
      {n:"45", name:"Princess Leia Strikes Back!", artist:null},
      {n:"46", name:"The Demise of Jabba the Hutt", artist:null},
      {n:"47", name:"Boba Fett's Last Stand", artist:null},
      {n:"48", name:"The Rescue", artist:null},
      {n:"49", name:"Gamorrean Guard", artist:null},
      {n:"50", name:"The Deadly Cannon", artist:null},
      {n:"51", name:"The Raging Battle", artist:null},
      {n:"52", name:"Princess Leia Swings into Action!", artist:null},
      {n:"53", name:"Swing to Safety", artist:null},
      {n:"54", name:"On the Death Star", artist:null},
      {n:"55", name:"Guards of the Emperor", artist:null},
      {n:"56", name:"The Deciders", artist:null},
      {n:"57", name:"The Emperor", artist:null},
      {n:"58", name:"Yoda, the Jedi Master", artist:null},
      {n:"59", name:"A Word with Ben (Obi-Wan) Kenobi", artist:null},
      {n:"60", name:"The Allies Meet", artist:null},
      {n:"61", name:"A New Challenge", artist:null},
      {n:"62", name:"Pondering the Raid", artist:null},
      {n:"63", name:"Mission: Destroy the Death Star!", artist:null},
      {n:"64", name:"Mon Mothma", artist:null},
      {n:"65", name:"The Friends Depart", artist:null},
      {n:"66", name:"Benevolent Creature", artist:null},
      {n:"67", name:"The Plan Begins", artist:null},
      {n:"68", name:"Forest of Endor", artist:null},
      {n:"69", name:"Droids on the Move", artist:null},
      {n:"70", name:"Blasting a Speeder Bike", artist:null},
      {n:"71", name:"Approaching the Princess", artist:null},
      {n:"72", name:"A New Found Friend", artist:null},
      {n:"73", name:"Princess Leia's Smile", artist:null},
      {n:"74", name:"Under Attack!", artist:null},
      {n:"75", name:"Imperial Scout Peril!", artist:null},
      {n:"76", name:"Entering the Throne Room", artist:null},
      {n:"77", name:"The Skywalker Factor", artist:null},
      {n:"78", name:"Captured by the Ewoks", artist:null},
      {n:"79", name:"The Netted Droid", artist:null},
      {n:"80", name:"All Hail See-Threepio!", artist:null},
      {n:"81", name:"Royal Treatment", artist:null},
      {n:"82", name:"Sitting with Royalty", artist:null},
      {n:"83", name:"Levitated by Luke", artist:null},
      {n:"84", name:"The Ewok Leaders", artist:null},
      {n:"85", name:"Logray and Chief Chirpa", artist:null},
      {n:"86", name:"Help from Princess Leia", artist:null},
      {n:"87", name:"Will Han Solo Be Dinner?", artist:null},
      {n:"88", name:"The Baby Ewok", artist:null},
      {n:"89", name:"The Forest Creatures", artist:null},
      {n:"90", name:"The Droid and the Ewok", artist:null},
      {n:"91", name:"R2-D2 Meets Wicket", artist:null},
      {n:"92", name:"Unexpected Allies", artist:null},
      {n:"93", name:"Serious Situation", artist:null},
      {n:"94", name:"Luke Skywalker's Destiny", artist:null},
      {n:"95", name:"Quiet, See-Threepio!", artist:null},
      {n:"96", name:"Imperial Biker Scout", artist:null},
      {n:"97", name:"Biker Scout and the Battlefield", artist:null},
      {n:"98", name:"Hans Solo's Approach", artist:null},
      {n:"99", name:"The Ultimate Mission", artist:null},
      {n:"100", name:"Ready for Action!", artist:null},
      {n:"101", name:"Ambushed by the Empire", artist:null},
      {n:"102", name:"Observed by the Ewoks", artist:null},
      {n:"103", name:"The Courageous Ewoks", artist:null},
      {n:"104", name:"Prisoners!", artist:null},
      {n:"105", name:"Revising Their Plan", artist:null},
      {n:"106", name:"AT-ST (All Terrain Scout Transport)", artist:null},
      {n:"107", name:"The Forest Fighters!", artist:null},
      {n:"108", name:"Break for Freedom!", artist:null},
      {n:"109", name:"Artoo-Detoo - Hit!", artist:null},
      {n:"110", name:"Chewbacca Triumphant!", artist:null},
      {n:"111", name:"Ewoks to the Rescue!", artist:null},
      {n:"112", name:"Battle in the Forest", artist:null},
      {n:"113", name:"Stormtrooper Attack!", artist:null},
      {n:"114", name:"The Victorious Rebels", artist:null},
      {n:"115", name:"Time Out for Love", artist:null},
      {n:"116", name:"Facing the Emperor", artist:null},
      {n:"117", name:"Master of Terror", artist:null},
      {n:"118", name:"The Emperor's Offer", artist:null},
      {n:"119", name:"Battle of the Jedi", artist:null},
      {n:"120", name:"Lightsaber Battle!", artist:null},
      {n:"121", name:"Darth Vader Is Down!", artist:null},
      {n:"122", name:"The Confrontation", artist:null},
      {n:"123", name:"The Death Star Raid", artist:null},
      {n:"124", name:"Military Leader Admiral Ackbar", artist:null},
      {n:"125", name:"Within the Death Star", artist:null},
      {n:"126", name:"Victory Celebration!", artist:null},
      {n:"127", name:"Congratulating Wedge", artist:null},
      {n:"128", name:"The Triumphant Trio", artist:null},
      {n:"129", name:"The Heroic Droids", artist:null},
      {n:"130", name:"Toward Brighter Tomorrows", artist:null},
      {n:"131", name:"Checklist I", artist:null},
      {n:"132", name:"Checklist II", artist:null},
    ]
  },
  {
    id: "base-series-2", type: "base", title: "BASE SERIES 2 — 88 CARDS",
    parallels: BASE_P,
    cards: [
      {n:"133", name:"88 Cards - 22 Stickers", artist:null},
      {n:"134", name:"Path to Destiny", artist:null},
      {n:"135", name:"Captured!", artist:null},
      {n:"136", name:"The Courageous Jedi", artist:null},
      {n:"137", name:"The Victors", artist:null},
      {n:"138", name:"Wicket and Princess Leia", artist:null},
      {n:"139", name:"The Emperor's Arrival", artist:null},
      {n:"140", name:"Sail Barge Battle!", artist:null},
      {n:"141", name:"Luke Skywalker, the Jedi", artist:null},
      {n:"142", name:"The Approach of Wicket", artist:null},
      {n:"143", name:"A Close Call!", artist:null},
      {n:"144", name:"Above the Sarlacc Pit", artist:null},
      {n:"145", name:"Admiral Ackbar's Defenders", artist:null},
      {n:"146", name:"R2-D2 on Endor", artist:null},
      {n:"147", name:"Boba Fett Attacks!", artist:null},
      {n:"148", name:"Deadly Plunge!", artist:null},
      {n:"149", name:"Lando Calrissian's Disguise", artist:null},
      {n:"150", name:"Soldiers of the Empire", artist:null},
      {n:"151", name:"A Curious Ewok", artist:null},
      {n:"152", name:"A Pensive Luke Skywalker", artist:null},
      {n:"153", name:"The Captive Princess", artist:null},
      {n:"154", name:"Luke Skywalker Surrenders", artist:null},
      {n:"155", name:"Thoughts of a Jedi", artist:null},
      {n:"156", name:"The Jaws of Death", artist:null},
      {n:"157", name:"Princess Leia Has the Force!", artist:null},
      {n:"158", name:"Arrival of the Emperor", artist:null},
      {n:"159", name:"Reunion on Endor", artist:null},
      {n:"160", name:"Toward the Sarlacc Pit", artist:null},
      {n:"161", name:"Sail Barge Creatures", artist:null},
      {n:"162", name:"Friends of the Alliance!", artist:null},
      {n:"163", name:"The Dreaded Rancor", artist:null},
      {n:"164", name:"Face of Terror", artist:null},
      {n:"165", name:"Inside Jabba the Hutt's Palace", artist:null},
      {n:"166", name:"The Ewok Village", artist:null},
      {n:"167", name:"A Collection of Creatures", artist:null},
      {n:"168", name:"Alert to Danger!", artist:null},
      {n:"169", name:"Walking the Plank!", artist:null},
      {n:"170", name:"A Gamorrean Guard Emerges", artist:null},
      {n:"171", name:"The Imperial Fleet", artist:null},
      {n:"172", name:"Jabba the Hutt on the Sail Barge", artist:null},
      {n:"173", name:"Escorted to the Ewok Village", artist:null},
      {n:"174", name:"A Monstrous Guest!", artist:null},
      {n:"175", name:"Village of the Ewoks", artist:null},
      {n:"176", name:"Aboard the Sail Barge", artist:null},
      {n:"177", name:"Confronting Their Destiny", artist:null},
      {n:"178", name:"\"Where's Princess Leia?\"", artist:null},
      {n:"179", name:"Horror from the Pit", artist:null},
      {n:"180", name:"\"Give in to Your Hate!\"", artist:null},
      {n:"181", name:"Awaiting His Majesty", artist:null},
      {n:"182", name:"A Mother Ewok and Child", artist:null},
      {n:"183", name:"A Concerned Princess Leia", artist:null},
      {n:"184", name:"Lead Singer Sy Snootles", artist:null},
      {n:"185", name:"The Arrival of Boushh", artist:null},
      {n:"186", name:"Master of His Court", artist:null},
      {n:"187", name:"Star Lovers", artist:null},
      {n:"188", name:"Luke Skywalker…Now a Jedi!", artist:null},
      {n:"189", name:"Battle of the Bunker!", artist:null},
      {n:"190", name:"Portrait of Wicket", artist:null},
      {n:"191", name:"Trapped by the Empire", artist:null},
      {n:"192", name:"Their Secret Revealed", artist:null},
      {n:"193", name:"Rethinking the Plan", artist:null},
      {n:"194", name:"Snagged by the Ewoks", artist:null},
      {n:"195", name:"Han Solo's in Trouble!", artist:null},
      {n:"196", name:"Is Han Solo Giving Up?", artist:null},
      {n:"197", name:"The Royal Droid", artist:null},
      {n:"198", name:"Princess Leia Intercedes", artist:null},
      {n:"199", name:"Rescuing Han Solo", artist:null},
      {n:"200", name:"Father Versus Son", artist:null},
      {n:"201", name:"Luke Skywalker, Jedi Warrior", artist:null},
      {n:"202", name:"The Young Jedi Knight", artist:null},
      {n:"203", name:"Han Solo Is Alive!", artist:null},
      {n:"204", name:"Lando Calrissian Undercover", artist:null},
      {n:"205", name:"Horrendous Creature", artist:null},
      {n:"206", name:"Corridors of the Imperial Destroyer", artist:null},
      {n:"207", name:"Surrounded by Ewoks", artist:null},
      {n:"208", name:"Gamorrean Guard Profile", artist:null},
      {n:"209", name:"Hulking Gamorrean Guard", artist:null},
      {n:"210", name:"Guests of Jabba the Hutt", artist:null},
      {n:"211", name:"A Full-Fledged Jedi!", artist:null},
      {n:"212", name:"Bizarre Alien Creatures", artist:null},
      {n:"213", name:"Headquarters Frigate", artist:null},
      {n:"214", name:"TIE Interceptor (3/4 View)", artist:null},
      {n:"215", name:"The Nearly Completed Death Star", artist:null},
      {n:"216", name:"Rebel Cruiser", artist:null},
      {n:"217", name:"TIE Interceptor (Front View)", artist:null},
      {n:"218", name:"The Emperor's Shuttle", artist:null},
      {n:"219", name:"Portrait of Chewbacca", artist:null},
      {n:"220", name:"Checklist 133-172", artist:null},
    ]
  },
  {
    id: "chrome-sticker-reprints", type: "insert", title: "CHROME STICKER REPRINTS — 55 CARDS",
    parallels: [
      {id:"superfractor",name:"Superfractor",print_run:1,color:"#f0c040"},
    ],
    cards: [
      {n:"1", name:"Yoda", artist:null},
      {n:"2", name:"Logray", artist:null},
      {n:"3", name:"Droopy McCool", artist:null},
      {n:"4", name:"Jabba the Hutt", artist:null},
      {n:"5", name:"Ree-Yees", artist:null},
      {n:"6", name:"Admiral Ackbar", artist:null},
      {n:"7", name:"Boushh", artist:null},
      {n:"8", name:"Han Solo", artist:null},
      {n:"9", name:"Princess Leia", artist:null},
      {n:"10", name:"Luke Skywalker", artist:null},
      {n:"11", name:"Han Solo", artist:null},
      {n:"12", name:"C-3PO", artist:null},
      {n:"13", name:"Chewbacca", artist:null},
      {n:"14", name:"Sy Snootles", artist:null},
      {n:"15", name:"Baby Ewok", artist:null},
      {n:"16", name:"Nien Nunb", artist:null},
      {n:"17", name:"Lando Calrission", artist:null},
      {n:"18", name:"R2-D2", artist:null},
      {n:"19", name:"Obi-Wan Kenobi", artist:null},
      {n:"20", name:"Luke Skywalker", artist:null},
      {n:"21", name:"Luke Skywalker", artist:null},
      {n:"22", name:"Gamorrean Guard", artist:null},
      {n:"23", name:"Salacious B. Crumb", artist:null},
      {n:"24", name:"Ewok", artist:null},
      {n:"25", name:"Boba Fett", artist:null},
      {n:"26", name:"Ewok", artist:null},
      {n:"27", name:"Jabba the Hutt", artist:null},
      {n:"28", name:"Lando in Disguise", artist:null},
      {n:"29", name:"Max Rebo", artist:null},
      {n:"30", name:"Leia", artist:null},
      {n:"31", name:"Leia", artist:null},
      {n:"32", name:"Han Solo", artist:null},
      {n:"33", name:"Biker Scout", artist:null},
      {n:"34", name:"Darth Vader", artist:null},
      {n:"35", name:"Luke Skywalker", artist:null},
      {n:"36", name:"Han Solo", artist:null},
      {n:"37", name:"Princess Leia", artist:null},
      {n:"38", name:"See-Threepio", artist:null},
      {n:"39", name:"Artoo-Detoo", artist:null},
      {n:"40", name:"Wicket", artist:null},
      {n:"41", name:"Admiral Ackbar", artist:null},
      {n:"42", name:"Chewbacca", artist:null},
      {n:"43", name:"The Emperor", artist:null},
      {n:"44", name:"Millennium Falcon", artist:null},
      {n:"45", name:"R2-D2 and C-3PO", artist:null},
      {n:"46", name:"Han Solo", artist:null},
      {n:"47", name:"Desert Skiff", artist:null},
      {n:"48", name:"Nien Nunb and Lando Calrissian", artist:null},
      {n:"49", name:"Princess Leia and Jabba the Hutt", artist:null},
      {n:"50", name:"Cast Photo", artist:null},
      {n:"51", name:"Princess Leia, Chewbacca and C-3PO", artist:null},
      {n:"52", name:"Darth Vader", artist:null},
      {n:"53", name:"R2-D2 and Wicket", artist:null},
      {n:"54", name:"Han Solo", artist:null},
      {n:"55", name:"Salacious B. Crumb", artist:null},
    ]
  },
  {
    id: "return-of-the-jedi-cast-autographs", type: "auto", title: "RETURN OF THE JEDI CAST AUTOGRAPHS — 8 CARDS",
    parallels: [
      {id:"purple-sapphire",name:"Purple Sapphire",print_run:10,color:"#cb7dff"},
      {id:"red-sapphire",name:"Red Sapphire",print_run:5,color:"#ff5d5d"},
      {id:"superfractor",name:"Superfractor",print_run:1,color:"#f0c040"},
    ],
    cards: [
      {n:"ROTJ-CF", name:"Carrie Fisher", artist:"Princess Leia Organa"},
      {n:"ROTJ-HF", name:"Harrison Ford", artist:"Han Solo"},
      {n:"ROTJ-IM", name:"Ian McDiarmid", artist:"The Emperor"},
      {n:"ROTJ-JB", name:"Jeremy Bulloch", artist:"Boba Fett"},
      {n:"ROTJ-KB", name:"Kenny Baker", artist:"R2-D2"},
      {n:"ROTJ-MH", name:"Mark Hamill", artist:"Luke Skywalker"},
      {n:"ROTJ-PM", name:"Peter Mayhew", artist:"Chewbacca"},
      {n:"ROTJ-WD", name:"Warwick Davis", artist:"Wicket W. Warrick"},
    ]
  },
];
